import { StyledParagraph, Link } from "../styled";

export const projects = [
    { title: 'mestwina', thumbnail: 'mestwina-front', type: 'hotel', id: 11 },
    { title: 'dąbrowskiego', thumbnail: 'dabrowskiego-front', type: 'hotel', id: 10 },
    { title: 'lubicz', thumbnail: 'lubicz-front', type: 'biuro', id: 9 },
    { title: 'rakowiecka', thumbnail: 'rakowiecka-front', type: 'wielo', id: 8 },
    { title: 'komandorska', thumbnail: 'komandorska-front', type: 'biuro', id: 7 },
    { title: 'poborzańska', thumbnail: 'poborzanska-front', type: 'wielo', id: 6 },
    { title: 'mińska', thumbnail: 'minska-front', type: 'wielo', id: 5 },
    { title: 'ratibora', thumbnail: 'ratibora-front', type: 'hotel', id: 4 },
    { title: 'izabelin', thumbnail: 'izabelin-front', type: 'jedno', id: 3 },
    { title: 'dachowa', thumbnail: 'dachowa-front', type: 'jedno', id: 2 },
    { title: 'piłsudskiego', thumbnail: 'pilsudskiego-front', type: 'hotel', id: 1 },
];

export const Mestwina = () => (
    <>
        <StyledParagraph>Jurata / ul. Mestwina / budynek apartamentowy <Link href="https://mestwina27.pl/" target="blank" rel="noopener noreferrer">MESTWINA27</Link> / Pc 1130 m²</StyledParagraph>
        <StyledParagraph>2022-obecnie / KONCEPCJA / PROJEKT BUDOWLANY / PROJEKT WYKONAWCZY /</StyledParagraph>
    </>
);

export const Dabrowskiego = () => (
    <>
        <StyledParagraph>Poznań / ul. Dąbrowskiego / akademik</StyledParagraph>
        <StyledParagraph>2021 / KONCEPCJA</StyledParagraph>
        <StyledParagraph>/ Grupa 5 Architekci + Studio Kosmos</StyledParagraph>
    </>
);

export const Lubicz = () => (
    <>
        <StyledParagraph>Kraków / ul. Lubicz / kompleks biurowy</StyledParagraph>
        <StyledParagraph>2019 / KONCEPCJA</StyledParagraph>
        <StyledParagraph>/ Grupa 5 Architekci + Studio Kosmos</StyledParagraph>
    </>
);

export const Rakowiecka = () => (
    <>
        <StyledParagraph>Warszawa / ul. Rakowiecka / budynek mieszkaniowy wielorodzinny z usługami / Pc 8.600 m²</StyledParagraph>
        <StyledParagraph>2017 – 2019 / KONCEPCJA / PROJEKT BUDOWLANY / PROJEKT WYKONAWCZY</StyledParagraph>
        <StyledParagraph>/ Grupa 5 Architekci + Studio Kosmos</StyledParagraph>
    </>
);

export const Komandorska = () => (
    <>
        <StyledParagraph>Wrocław / ul. Komandorska / budynek biurowy / Pc 5.608 m²</StyledParagraph>
        <StyledParagraph>2013-19 | KONCEPCJA | PROJEKT BUDOWLANY | PROJEKT WYKONAWCZY | NADZÓR | KOMERCJALIZACJA</StyledParagraph>
        <StyledParagraph>
        <Link href="" target="blank" rel="noopener noreferrer">BRICK AWARD 2019 / WYRÓŻNIENIE</Link>
        <br/>
        <Link href="" target="blank" rel="noopener noreferrer">ARCHITEKTURA-MURATOR / 06/2017 / REALIZACJE</Link>
        <br/>
        <Link href="" target="blank" rel="noopener noreferrer">ARCHITEKTURA-MURATOR / 01/2017 / WARSZTAT</Link>
        </StyledParagraph>
        <StyledParagraph>/ Grupa 5 Architekci + Studio Kosmos</StyledParagraph>
    </>
);

export const Poborzanska = () => (
    <>
        <StyledParagraph>Warszawa / ul. Poborzańska / budynek mieszkalny wielorodzinny / Pc 4.199 m²</StyledParagraph>
        <StyledParagraph>2014-2016 / KONCEPCJA / PROJEKT BUDOWLANY / PROJEKT WYKONAWCZY / NADZÓR</StyledParagraph>
        <StyledParagraph>/ Grupa 5 Architekci + Studio Kosmos</StyledParagraph>
    </>
);

export const Minska = () => (
    <>
        <StyledParagraph>Warszawa / ul. Mińska / zespół budynków mieszk. wielorodzinnych / Pc 120.300 m²</StyledParagraph>
        <StyledParagraph>2017 / ANALIZA CHŁONNOŚCI / KONCEPCJA</StyledParagraph>
        <StyledParagraph>/ Grupa 5 Architekci + Studio Kosmos</StyledParagraph>
    </>
);

export const Ratibora = () => (
    <>
        <StyledParagraph>Jurata / ul. Ratibora / budynek apartamentowy <Link href="https://deckjurata.pl/" target="blank" rel="noopener noreferrer">DECK JURATA</Link> / Pc 615 m²</StyledParagraph>
        <StyledParagraph>2016-2019 / KONCEPCJA / PROJEKT BUDOWLANY / PROJEKT WYKONAWCZY / NADZÓR</StyledParagraph>
    </>
);

export const Izabelin = () => (
    <>
        <StyledParagraph>Izabelin / budynek mieszkalny jednorodzinny / Pc 603 m²</StyledParagraph>
        <StyledParagraph>2011-16 / KONCEPCJA / PROJEKT BUDOWLANY / PROJEKT WYKONAWCZY / NADZÓR</StyledParagraph>
    </>
);

export const Dachowa = () => (
    <>
        <StyledParagraph>Dachowa / dom jednorodzinny z zabudowaniami towarzyszącymi / Pc 350 m²</StyledParagraph>
        <StyledParagraph>2014-15 / KONCEPCJA / PROJEKT BUDOWLANY / PROJEKT WYKONAWCZY / NADZÓR</StyledParagraph>
        <StyledParagraph>
        <Link href="" target="blank" rel="noopener noreferrer">FINALISTA V4 Family Houses 2014</Link>
        </StyledParagraph>
    </>
);

export const Pilsudskiego = () => (
    <>
        <StyledParagraph>Piła / ul. Piłsudskiego / budynek hotelowo-mieszkalny / Pc 13.250 m²</StyledParagraph>
        <StyledParagraph>2017-2021 / PROJEKT BUDOWLANY / PROJEKT WYKONAWCZY / NADZÓR</StyledParagraph>
        <StyledParagraph>/ Grupa 5 Architekci + Studio Kosmos</StyledParagraph>
    </>
);




